const firmwareUpdate = document.getElementById("firmware-update");

if (firmwareUpdate) {
    firmwareUpdate.innerHTML = '<label for="firmware-input" class="firmware-update-label">Please insert your firmware version code here:</label> <input name="firmware-input" id="firmware-input" type="text" value="" maxlength="4" aria-invalid="false" class="field__input"> <div id="firmware-promt"></div>';
}

const inputBox = document.getElementById("firmware-input");
const firwarePromt = document.getElementById("firmware-promt");

// b002, b022, b025 - No update required
// b017, b021 - Update required to b022
// ntcs - Update required to b023
// b023 - Update required to b025

if (inputBox) {
    inputBox.onkeyup = function(){
        switch(inputBox.value.toUpperCase()) {
            case "NTCS":
                firwarePromt.innerHTML = '<p style="color:#FEB92F;">Your smoker needs a firmware update <a href="https://dl.dropboxusercontent.com/s/8kbt8f9t2poipyw/BWFRIMWARE.bin?dl=0" download>click here</a>  to download</p>'
                break;
            case "B023":
                firwarePromt.innerHTML = '<p style="color:#FEB92F;">Your smoker needs a firmware update <a href="https://dl.dropboxusercontent.com/s/scws1ytr3385tw5/BWFRIMWARE.bin?dl=0" download>click here</a>  to download</p>'
                break;
            case "B017": case "B021":
                firwarePromt.innerHTML = '<p style="color:#FEB92F;">Your smoker needs a firmware update <a href="https://dl.dropboxusercontent.com/s/rj0vc7htdv6w9tn/BWFRIMWARE.bin?dl=0" download>click here</a>  to download</p>'
              break;
            case "B022": case "B002" : case "B025" : case "B028" :
                firwarePromt.innerHTML = '<p style="color:#89A805;">Your smoker uses the latest software. Happy Smoking!</p>'
              break;
            default:
                if(inputBox.value.includes("2401")){
                  firwarePromt.innerHTML = '<p style="color:#FEB92F;">Your smoker needs a firmware update <a target="_blank" href="https://www.dropbox.com/scl/fi/i8ug7ttlvg6rj6bupj7zh/BWFRIMWARE.bin?rlkey=b9je6fcmip1dl33vzojtia7yq&st=ksu7cg66&dl=0" download>click here</a>  to download</p>'
                }else if(inputBox.value.length === 4){
                    firwarePromt.innerHTML = '<p style="color:#D53126;">Please enter the correct firmware code displayed on your smoker</p>'
                } else {
                    firwarePromt.innerHTML = ''
                }
                
        }

    }
}